document.querySelectorAll('[data-offer]').forEach((root) => {
  // Multiple sections (hero, offer, sticky-cta) each include this script, so
  // it can execute more than once on the same page. Guard against binding
  // the same root twice, which would double-fire add-to-cart/buy-now.
  if (root.dataset.offerBound) return;
  root.dataset.offerBound = 'true';

  const unitPrice = parseInt(root.dataset.unitPrice, 10) || 0;
  const unitCompare = parseInt(root.dataset.unitCompare, 10) || 0;
  const currency = root.dataset.currency;
  const variantId = root.dataset.variantId;

  const qtyValueEl = root.querySelector('[data-qty-value]');
  const qtyInputEl = root.querySelector('[data-qty-input]');
  const totalEls = root.querySelectorAll('[data-total-price]');
  const compareEl = root.querySelector('[data-compare-price]');
  const saveEl = root.querySelector('[data-save-percent]');
  const decBtn = root.querySelector('[data-qty-dec]');
  const incBtn = root.querySelector('[data-qty-inc]');
  const addBtn = root.querySelector('[data-add-to-cart]');
  const buyNowBtn = root.querySelector('[data-buy-now]');

  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0,
  });

  let qty = 1;

  function render() {
    if (qtyValueEl) qtyValueEl.textContent = qty;
    if (qtyInputEl) qtyInputEl.value = qty;
    totalEls.forEach((el) => { el.textContent = formatter.format((unitPrice * qty) / 100); });
    if (compareEl && unitCompare > unitPrice) {
      compareEl.textContent = formatter.format((unitCompare * qty) / 100);
    }
    if (saveEl && unitCompare > unitPrice) {
      saveEl.textContent = Math.round((1 - unitPrice / unitCompare) * 100) + '%';
    }
    if (decBtn) decBtn.disabled = qty <= 1;
  }

  decBtn?.addEventListener('click', () => {
    if (qty > 1) {
      qty -= 1;
      render();
    }
  });

  incBtn?.addEventListener('click', () => {
    if (qty < 10) {
      qty += 1;
      render();
    }
  });

  addBtn?.addEventListener('click', async () => {
    if (!variantId || addBtn.disabled) return;
    const originalLabel = addBtn.textContent;
    addBtn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      });

      if (!response.ok) throw new Error('add to cart failed');

      addBtn.textContent = root.dataset.addedLabel || 'Added';

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      addBtn.textContent = root.dataset.errorLabel || 'Error, try again';
    } finally {
      setTimeout(() => {
        addBtn.textContent = originalLabel;
        addBtn.disabled = false;
      }, 1800);
    }
  });

  buyNowBtn?.addEventListener('click', async () => {
    if (!variantId || buyNowBtn.disabled) return;
    const originalLabel = buyNowBtn.textContent;
    buyNowBtn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      });

      if (!response.ok) throw new Error('add to cart failed');

      window.location.href = '/checkout';
    } catch (error) {
      buyNowBtn.textContent = root.dataset.errorLabel || 'Error, try again';
      setTimeout(() => {
        buyNowBtn.textContent = originalLabel;
        buyNowBtn.disabled = false;
      }, 1800);
    }
  });

  render();
});
